module.exports = __webpack_public_path__ + "img/set_theme_8.279d2896.png";